import { io, Socket } from "socket.io-client"
import { useAuthStore } from "../../stores/auth-store"
import { keys } from "../../keys"

let socket: Socket | null = null

export function initSocket(): Socket {
  if (socket?.connected) {
    return socket
  }

  const token = useAuthStore.getState().token

  socket = io(keys.SOCKET_URL, {
    auth: {
      token,
    },
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
  })

  socket.on("connect", () => {
    // Connected
  })

  socket.on("disconnect", () => {
    // Disconnected
  })

  socket.on("connect_error", () => {
    // Connection error
  })

  return socket
}

export function getSocket(): Socket | null {
  return socket
}

export function disconnectSocket(): void {
  if (socket) {
    socket.disconnect()
    socket = null
  }
}

// Re-export for convenience
export { socket }
